import React from 'react';
import { ArrowRight, Package, Plane } from 'lucide-react';

export const Hero = () => {
  const scrollToTracking = () => {
    const element = document.getElementById('tracking');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative pt-20 lg:pt-24 pb-16 lg:pb-20 overflow-hidden bg-gradient-to-b from-blue-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-8 lg:pr-8">
            <div className="inline-flex items-center space-x-2 bg-[#F3A530]/10 px-4 py-2 rounded-full">
              <Plane size={20} className="text-[#F3A530]" />
              <span className="text-sm font-medium text-[#204FA7]">Livraison internationale express</span>
            </div>

            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-[#204FA7] leading-tight">
              Envoyez et recevez vos colis en{' '}
              <span className="text-[#F3A530]">48h</span>
            </h1>

            <div className="flex items-center space-x-4 text-lg sm:text-xl text-gray-700">
              <div className="flex items-center space-x-2">
                <div className="w-8 h-8 rounded-full bg-blue-100 flex items-center justify-center">
                  <span className="text-sm">🇫🇷</span>
                </div>
                <span className="font-semibold">Paris</span>
              </div>
              <div className="flex items-center space-x-2">
                <ArrowRight className="text-[#1CA1CC]" />
                <ArrowRight className="text-[#1CA1CC] -ml-4" />
              </div>
              <div className="flex items-center space-x-2">
                <div className="w-8 h-8 rounded-full bg-orange-100 flex items-center justify-center">
                  <span className="text-sm">🇨🇮</span>
                </div>
                <span className="font-semibold">Abidjan</span>
              </div>
            </div>

            <p className="text-lg text-gray-600 max-w-xl">
              Service de transport et import-export fiable et sécurisé entre la France et la Côte d'Ivoire. 
              Vos colis en toute sécurité, livrés rapidement.
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <a 
                href="https://app.rapidecolisexpress.com/package/track"
                target="_blank"
                className="group bg-[#204FA7] text-white px-8 py-4 rounded-lg hover:bg-[#1a3f87] transition-all shadow-lg hover:shadow-xl flex items-center justify-center space-x-2 font-semibold"
              >
                <Package size={20} />
                <span>Suivre mon colis</span>
                <ArrowRight size={20} className="group-hover:translate-x-1 transition-transform" />
              </a>
              
              <a 
                href="https://wa.me/33695701735?text=Bonjour,%20je%20souhaite%20envoyer%20un%20colis"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-white text-[#204FA7] border-2 border-[#204FA7] px-8 py-4 rounded-lg hover:bg-[#204FA7] hover:text-white transition-all shadow-md hover:shadow-lg flex items-center justify-center space-x-2 font-semibold"
              >
                <span>Envoyer un colis</span>
              </a>
            </div>

            {/* Trust Indicators */}
            <div className="grid grid-cols-3 gap-6 pt-8 border-t border-gray-200">
              <div>
                <p className="text-2xl font-bold text-[#204FA7]">48h</p>
                <p className="text-sm text-gray-600">Livraison rapide</p>
              </div>
              <div>
                <p className="text-2xl font-bold text-[#204FA7]">100%</p>
                <p className="text-sm text-gray-600">Sécurisé</p>
              </div>
              <div>
                <p className="text-2xl font-bold text-[#204FA7]">7j/7</p>
                <p className="text-sm text-gray-600">Support client</p>
              </div>
            </div>
          </div>

          {/* Right Image */}
          <div className="relative lg:h-[600px]">
            <div className="relative h-full rounded-2xl overflow-hidden shadow-2xl">
              <img 
                src="https://images.unsplash.com/photo-1718314740490-1463a6152cdd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwxfHxpbnRlcm5hdGlvbmFsJTIwc2hpcHBpbmd8ZW58MHx8fHwxNzc0ODA1OTg0fDA&ixlib=rb-4.1.0&q=85"
                alt="Transport international" 
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#204FA7]/30 to-transparent"></div>
            </div>
            
            {/* Floating Card */}
            <div className="absolute bottom-8 left-8 right-8 bg-white p-6 rounded-xl shadow-xl">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm text-gray-600">Colis en transit</p>
                  <p className="text-xl font-bold text-[#204FA7]">Paris → Abidjan</p>
                </div>
                <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
                  <Package className="text-green-600" size={24} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
